module.exports = __webpack_public_path__ + "img/landos-logo.png?1cf49952207a9c76e5d10c4852b5fe28";